<template>
  <div class="adjustment column-me">
    <div class="tab-div row-me">
      <div class="tab-item column-me row-center" @click="clickTab(0)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===0}">待调剂列表</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===0}"></div>
      </div>
      <div class="tab-item column-me row-center" @click="clickTab(1)">
        <div class="tab-title" :class="{'tab-title-active':tabIndex===1}">调剂查询</div>
        <div class="tab-line" :class="{'tab-line-active':tabIndex===1}"></div>
      </div>
    </div>

    <!--待调剂列表、调剂查询、待入库列表-->
    <div class="card-div column-me flex1">
      <div class="row-me row-center flex-wrap">
        <div class="width180">
          <el-input placeholder="处方订单号" style="width: 100%;" clearable v-model="number"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-input placeholder="患者姓名" style="width: 100%;" clearable v-model="name"></el-input>
        </div>
        <div class="width150 margin-left10">
          <el-select placeholder="医院名称" style="width: 100%;" filterable clearable v-model="hospital">
            <el-option v-for="item in hospitalArray" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div class="width120 margin-left10">
          <el-input placeholder="机构名称" style="width: 100%;" clearable v-model="organization"></el-input>
        </div>
        <div class="width130 margin-left10" v-if="tabIndex===1">
          <el-select placeholder="处方状态" style="width: 100%;" filterable clearable v-model="selectState">
            <el-option v-for="item in stateArray" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width130 margin-left10" v-if="tabIndex===1">
          <el-select placeholder="日期类型" style="width: 100%;" filterable clearable v-model="selectDateType">
            <el-option v-for="item in [{id:0,name:'传方日期'},{id:1,name:'操作日期'}]" :key="item.id" :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="width300 margin-left10">
          <el-date-picker type="daterange" range-separator="-" start-placeholder="开始日期"
                          end-placeholder="结束日期" value-format="YYYY-MM-DD" clearable v-model="selectDate">
          </el-date-picker>
        </div>
        <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSearch">
          <el-icon>
            <search/>
          </el-icon>
          搜索
        </div>
        <div class="btn-blank width100 btn-height40 margin-left10" @click="clickClear">清空</div>
      </div>
      <div class="row-me row-center margin-top20">
        <div class="row-me row-center" v-if="tabIndex===0&&canOperate">
          <div class="btn-green width120 btn-height40 margin-right10" @click="clickPass">调剂完成</div>
          <div class="btn-red width120 btn-height40 margin-right10" @click="clickDelete">调剂作废</div>
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickAddRemark" v-if="canOperate">添加备注
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickPrintTransfer">
          打印调配单
        </div>
        <div class="btn-blank width140 btn-height40 margin-right10" @click="clickPrintBarCode">
          打印调配条码
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickPrintLabel">
          打印标签
        </div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickExport">导出处方</div>
        <div class="btn-blank width120 btn-height40 margin-right10" @click="clickExportMedicine">导出药品</div>
        <div class="btn-blank width150 btn-height40 margin-right10" @click="clickExportAll">导出处方及药品</div>
      </div>
      <div class="column-me flex1 margin-top20 overflow-hidden">
        <div class="flex1 overflow-auto">
          <el-table :data="tableData" border header-cell-class-name="table-header-style"
                    cell-class-name="table-cell-style" @selection-change="selectionChange"
                    @row-click='rowClick' :row-class-name="tableRowClassName" height="100%">
            <el-table-column type="selection" align="center" width="50"></el-table-column>
            <el-table-column prop="orderNo" label="处方订单号" align="center" width="250"></el-table-column>
            <el-table-column prop="hospitalName" label="医院名称" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mechName" label="机构名称" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="prescriptionNumber" label="医院单号" align="center" width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="patientName" label="患者姓名" align="center" width="100"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="处方类型" align="center" width="100" show-overflow-tooltip>
              <template v-slot="scope">
                {{ scope.row.type === 0 ? '中药处方' : scope.row.type === 1 ? '中医外治' : '' }}
              </template>
            </el-table-column>
            <el-table-column prop="processType" label="加工类型" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="isDecoction" label="是否代煎" align="center" width="100">
              <template #default='scope'>
                <div v-if="scope.row.val === 't' || scope.row.val === 'd' || scope.row.val === 'z'">
                  {{ scope.row.isDecoction ? '代煎' : '自煎' }}
                </div>
                <div v-else>代煎</div>
              </template>
            </el-table-column>
            <el-table-column prop="packageNums" label="包装量" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="doseNums" label="剂数" align="center" width="80"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="frequency" label="次数" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="takeMethod" label="服用方法" align="center" width="130"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="decoctSchemeContent" label="煎药方案" align="center" width="250"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="mergeOrderNo" label="合单工单号" align="center" width="200"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="医生手签" align="center" width="130">
              <template #default='scope'>
                <el-image :src="scope.row.doctorSignature" :preview-src-list="[scope.row.doctorSignature]"
                          fit="scale-down" class="img-sign" hide-on-click-modal>
                  <template #error>
                    <img src="../../assets/img/no_img_small.png" slot="error"
                         class="width100Per height100Per objScaleDown">
                  </template>
                </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="remark" label="传方备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="传方时间" align="center" width="220"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="处方状态" align="center" width="100" show-overflow-tooltip>
              <template #default='scope'>
                <div v-if="scope.row.tiaoStatus===0">调剂作废</div>
                <div v-if="scope.row.tiaoStatus===1">待调剂</div>
                <div v-if="scope.row.tiaoStatus===2">复核驳回</div>
                <div v-if="scope.row.tiaoStatus===3">调剂完成</div>
              </template>
            </el-table-column>
            <el-table-column prop="tiaoOperatorTime" label="操作时间" align="center" width="220"
                             show-overflow-tooltip v-if="tabIndex===1"></el-table-column>
            <el-table-column prop="tiaoOperator" label="操作人" align="center" width="120"
                             show-overflow-tooltip v-if="tabIndex===1"></el-table-column>
            <el-table-column prop="tiaoRemark" label="调剂备注" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column prop="receiveName" label="收件人" align="center" width="120"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="收件人地址" align="center" width="180" show-overflow-tooltip>
              <template #default='scope'>
                {{ scope.row.receiveProvince }}{{ scope.row.receiveCity }}
                {{ scope.row.receiveRegion }}{{ scope.row.receiveAddress }}
              </template>
            </el-table-column>
            <el-table-column prop="receiveMobile" label="收件电话" align="center" width="150"
                             show-overflow-tooltip></el-table-column>
            <el-table-column label="配送方式" align="center" width="130"
                             show-overflow-tooltip>
              <template #default='scope'>
                <div class="row-me center-all">
                  <div>{{ scope.row.deliveryCompany }}</div>
                  <div v-if="scope.row.deliveryType===0">(寄付)</div>
                  <div v-if="scope.row.deliveryType===1">(到付)</div>
                  <div v-if="scope.row.deliveryType===2">(月结)</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="margin-top20">
          <el-pagination background @current-change="handleCurrentChange" :current-page.sync="pageNo"
                         layout="total, prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 调剂作废 -->
    <el-dialog title="调剂作废" v-model="visibleDelete" width="40%" :destroy-on-close="true">
      <deleteFang :ids="ids" source="调剂"></deleteFang>
    </el-dialog>

    <!-- 调剂详情 -->
    <el-dialog v-model="visibleDetail" width="95%" :before-close="beforeClose" :destroy-on-close="true" top="3vh"
               custom-class="detail-fang">
      <template #title>
        <div class="row-me row-center">
          <div class="dialog-title">{{ selectItem.orderNo }}&emsp;{{ selectItem.patientName }}</div>
          <div class="btn-next row-me center-all" @click="clickLeft">
            <el-icon color="#FFFFFF" style="margin-right: 0;">
              <arrowleft/>
            </el-icon>
            <span>上一个</span>
          </div>
          <div class="btn-next row-me center-all" @click="clickRight">
            <span>下一个</span>
            <el-icon color="#FFFFFF" style="margin-right: 0;">
              <arrowright/>
            </el-icon>
          </div>
        </div>
      </template>
      <fangDetail :id="selectItem.id"></fangDetail>
    </el-dialog>

    <!-- 添加备注 -->
    <el-dialog title="添加备注" v-model="visibleRemark" width="820px" top="20vh" :destroy-on-close="true">
      <div class="padding10-20">
        <div class="flex1">
          <el-input type="textarea" placeholder="请输入备注" style="width: 100%;" clearable v-model="remark"
                    maxlength="500" show-word-limit rows="10"></el-input>
        </div>
        <div class="row-me row-center flex-end1 margin-top40">
          <div class="btn-blank width100 btn-height40" @click="visibleRemark=false">取消</div>
          <div class="btn-blue width100 btn-height40 margin-left10" @click="clickSaveRemark">保存</div>
        </div>
      </div>
    </el-dialog>

    <!-- 打印调配单 -->
    <div v-show="false" v-if="ids&&ids.length>0">
      <printPrescription ref="printPage" :ids="ids"></printPrescription>
    </div>

    <!-- 打印调配码 -->
    <el-drawer v-model="showCodeDrawer" title="打印调配条码" direction="rtl" :destroy-on-close="true">
      <printTransferCode :persons="selectOrderArray"></printTransferCode>
    </el-drawer>

    <!-- 打印标签 -->
    <el-drawer v-model="showLabelDrawer" title="打印标签" direction="rtl" :destroy-on-close="true">
      <printLabel :persons="selectOrderArray"></printLabel>
    </el-drawer>


  </div>
</template>

<script>
import deleteFang from './deleteFang.vue'
import fangDetail from './fangDetail.vue'
import printPrescription from './printPrescription.vue'
import printTransferCode from './printTransferCode.vue'
import printLabel from './printLabel.vue'

export default {
  components: {
    deleteFang,
    fangDetail,
    printPrescription,
    printTransferCode,
    printLabel,
  },
  data() {
    return {
      tabIndex: 0,
      number: '',
      name: '',
      hospital: '',
      hospitalArray: [],
      selectState: '',
      stateArray: [{id: 19, name: '调剂完成'}, {id: 14, name: '调剂作废'}],
      selectDateType: 0,
      organization: '',
      selectDate: [],
      tableData: [],
      pageNo: 1,
      total: 0,
      visibleDelete: false,
      visibleDetail: false,
      selectItem: {}, //选择的处方
      ids: [], //选择框选择的id
      visibleRemark: false,
      remark: '',
      showCodeDrawer: false,
      showLabelDrawer: false,
      selectOrderArray: [],//选择的患者
      canOperate: false,
    }
  },
  // html加载完成之前
  created() {
    this.$getMenuOperateAuth(this.$route.path).then(res => {
      this.canOperate = res.data
    })
    this.getHospitalArray()
    this.pageNo = 1
    this.getData()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    clickTab(index) {
      this.tabIndex = index
      this.clickSearch()
    },
    clickSearch() {
      this.pageNo = 1
      this.getData()
    },
    clickClear() {
      this.number = ''
      this.name = ''
      this.hospital = ''
      this.organization = ''
      this.selectState = ''
      this.selectDateType = 0
      this.selectDate = []
      this.pageNo = 1
      this.getData()
    },
    //选择
    selectionChange(e) {
      this.selectOrderArray = e
      let ids = []
      for (let item of e) {
        ids.push(item.id)
      }
      this.ids = ids
    },
    //赋值每一行的下标
    tableRowClassName({row, rowIndex}) {
      row.index = rowIndex;
    },
    //某一行点击
    rowClick(row, column, event) {
      if (column.no !== 0 && column.no !== 1 && column.no !== 15) {
        this.selectItem = row
        this.visibleDetail = true
      }
    },
    beforeClose(done) {
      this.getData()
      done()
    },
    //上一个
    clickLeft() {
      let index = this.selectItem.index
      if (index > 0) {
        index--
      } else {
        this.$message.error('已经是当前页的第1条')
      }
      this.selectItem = this.tableData[index]
    },
    //下一个
    clickRight() {
      let index = this.selectItem.index
      if (index < this.tableData.length - 1) {
        index++
      } else {
        this.$message.error('已经是当前页的最后一条')
      }
      this.selectItem = this.tableData[index]
    },
    //调剂完成
    clickPass() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.$confirm("您确定要调剂完成吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$postFormRequest('/admin/order/tiaojiFinish', {
          ids: this.ids,
          type: 1,//0驳回，1完成
          remark: '',
        }).then((res) => {
          if (res) {
            this.$message.success(res.message)
            this.pageNo = 1
            this.getData()
          }
        }).catch((error) => {
          console.log(error)
        })
      }).catch(() => {
      });
    },
    //调剂作废
    clickDelete() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.visibleDelete = true
      this.bus.$off('deleteFangSuccess')
      this.bus.$on('deleteFangSuccess', res => {
        this.visibleDelete = false
        if (res === 'refresh') {
          this.pageNo = 1
          this.getData()
        }
      })
    },
    //添加备注
    clickAddRemark() {
      if (this.ids.length === 0) {
        this.$message.error('请先选择订单')
        return
      }
      this.remark = ''
      this.visibleRemark = true
    },
    //保存备注
    clickSaveRemark() {
      if (this.$method.isEmpty(this.remark)) {
        this.$message.error('请输入备注')
        return
      }
      this.$postRequest('/admin/order/jieAddRemark', {
        ids: this.ids,
        remark: this.remark,
        type: 4,//1接方 2审方 3执行入库 4调剂添加备注, 5复核添加备注, 6泡药，7煎药，8包装，9发货
      }).then((res) => {
        if (res) {
          this.visibleRemark = false
          this.remark = ''
          this.$message.success('添加成功')
          this.getData()
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //打印调配单
    clickPrintTransfer() {
      if (this.ids.length === 0) {
        this.$message.error("请先选择订单")
        return
      }
      this.$refs.printPage.getDetail()
    },
    //打印调配条形码
    clickPrintBarCode() {
      if (this.ids.length === 0) {
        this.$message.error("请先选择订单")
        return
      }
      this.showCodeDrawer = true
    },
    //打印标签
    clickPrintLabel() {
      if (this.ids.length === 0) {
        this.$message.error("请先选择订单")
        return
      }
      this.showLabelDrawer = true
    },
    //导出处方
    clickExport() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 93 : this.tabIndex === 1 ? 94 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? '' : this.tabIndex === 1 ? this.selectState : '',
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/orderExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //导出药品
    clickExportMedicine() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 93 : this.tabIndex === 1 ? 94 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? '' : this.tabIndex === 1 ? this.selectState : '',
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/drugExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //导出处方及药品
    clickExportAll() {
      let token = sessionStorage.getItem('token')
      let param = {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 93 : this.tabIndex === 1 ? 94 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? '' : this.tabIndex === 1 ? this.selectState : '',
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
        token: token,
      }
      let url = this.$baseUrl + '/admin/order/orderAndDrugExport?' + this.$method.getParamsString(param)
      window.open(url)
    },
    //页数改变
    handleCurrentChange(pageNo) {
      this.pageNo = pageNo
      this.getData()
    },
    //获取数据
    getData() {
      this.$getRequest('/admin/order/page', {
        orderNo: this.number,
        patientName: this.name,
        hospitalName: this.hospital,
        mechName: this.organization,
        status: this.tabIndex === 0 ? 93 : this.tabIndex === 1 ? 94 : '',
        //订单状态 0 已作废 1 待接方列表 2 待审方
        // 90接方查询，91审方查询，92待入库列表，93带调剂列表，
        // 94调剂查询 ，95待复核列表 96复核查询, 97带泡药列表 98泡药查询 99带煎药列表 100煎药查询, 101 带包装列表，
        // 102包装查询，103待发货列表，104发货查询，105处方查询
        prescriptionStatus: this.tabIndex === 0 ? '' : this.tabIndex === 1 ? this.selectState : '',
        //v27 处方状态，0待审方，1待复核，2代调剂，3带泡药，4正在泡药，5代煎药，6正在煎药，
        // 7带包装，8正在包装，9待发货，10已发货，11待接方，12接方作废，13审方作废，14调剂作废，15接方通过，16审方通过，
        // 17待入库，18已入库，19调剂完成，20复核驳回，21复核完成
        start: this.selectDate[0] ? this.selectDate[0] : '',
        end: this.selectDate[1] ? this.selectDate[1] : '',
        dateType: this.tabIndex === 0 ? '' : this.selectDateType,//v27 日期类型，0传方，1操作, 2泡药煎药时间
        pageNumber: this.pageNo,
      }).then((res) => {
        if (res) {
          this.total = res.data.totalRow
          this.tableData = res.data.list
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //获取医院下拉
    getHospitalArray() {
      this.$getRequest('/admin/hospital/list', {}).then((res) => {
        if (res) {
          this.hospitalArray = res.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
}
</script>

<style lang="scss" scoped>
.adjustment {
  height: 100%;

  .tab-div {
    background: #FFFFFF;
    margin: 20px 20px 0 20px;
    padding: 20px 0 0 0;

    .tab-item {
      padding: 0 20px;
      cursor: pointer;

      .tab-title {
        font-size: 18px;
        padding-bottom: 20px;

        &-active {
          color: #215AA0;
          font-weight: bold;
        }
      }

      .tab-line {
        width: 100%;
        height: 2px;
        background: #FFFFFF;
        border-radius: 1px;

        &-active {
          background: #215AA0;
        }
      }
    }
  }

  .card-div {
    margin: 20px;
    background: #FFFFFF;
    box-shadow: 0 0 5px #F3F3F3;
    border-radius: 3px;
    padding: 20px;
    overflow: auto;

    .red-point {
      width: 10px;
      height: 10px;
      background: #F46161;
      border-radius: 50%;
    }

    .img-sign {
      width: 90px;
      height: 30px;
    }

    .title1 {
      font-size: 22px;
      color: #252525;
    }

    .line-grey-shu {
      background: #E5E9ED;
      margin: 0 25px;
    }

    .left-div {
      width: 110px;
      text-align: right;
      margin-right: 10px;
    }

    .item-drug {
      width: 370px;
      height: 60px;
      background: #F5F6F8;
      padding: 20px;
      border-radius: 4px;
      margin-right: 10px;
      margin-bottom: 10px;

      &:nth-child(4n) {
        margin-right: 0;
      }
    }
  }
}

.dialog-title {
  font-size: 18px;
  color: #FFFFFF;
  margin-left: 20px;
}

.btn-next {
  width: 95px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  border: 1px solid #FFFFFF;
  border-radius: 17px;
  font-size: 16px;
  color: #FFFFFF;
  cursor: pointer;
  margin-left: 20px;
}
</style>
